import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
`;

const Spinner = styled.div`
  border: 3px solid #f3f3f3;
  border-top: 3px solid var(--primary-red);
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  
  ${props => {
    switch (props.size) {
      case 'sm':
        return 'width: 1rem; height: 1rem;';
      case 'md':
        return 'width: 2rem; height: 2rem;';
      case 'lg':
        return 'width: 3rem; height: 3rem;';
      default:
        return 'width: 2rem; height: 2rem;';
    }
  }}
`;

const LoadingText = styled.p`
  color: var(--text-secondary);
  font-size: 0.875rem;
  margin: 0;
`;

const LoadingSpinner = ({ size = 'md', text = 'Loading...', className }) => {
  return (
    <SpinnerContainer className={className}>
      <Spinner size={size} />
      {text && <LoadingText>{text}</LoadingText>}
    </SpinnerContainer>
  );
};

export default LoadingSpinner;
